export default {
  CHAR: "text",
  TINYTEXT: "text",
  TEXT: "textarea",
  MEDIUMTEXT: "textarea",
  LONGTEXT: "textarea",
  VARCHAR: "text",
  BIGINT: "integer",
  INT: "integer",
  TINYINT: "bool",
  TIMESTAMP: "date",
  FLOAT: "number",
  DOUBLE: "number",
  DECIMAL: "number",
  ENUM: "select",
  SET: "select"
}
